import { InputIconHelper } from "./InputIconHelper";
export class InputEventHelper {
    constructor($elem, $parent, $icon) {
        this.$elem = $elem;
        this.$parent = $parent;
        this.$icon = $icon;
        this.iconHelper = new InputIconHelper($elem, $icon);
        this.$passwordValidiation = $parent.find(".ax-password-validation");
        this.isPassword = $elem.is(":password");
        if (this.isPassword) {
            this.iconHelper.togglePasswordIcon();
        }
    }
    focus() {
        this.$elem.addClass("active");
    }
    keyup() {
        let tmpval = this.$elem.val();
        let hasValue = tmpval != "";
        this.$parent.removeClass("field-error");
        this.$elem.toggleClass("value", hasValue);
        if (this.isPassword) {
            this.$passwordValidiation.css("display", hasValue ? "flex" : "none");
            if (hasValue && this.$elem.hasClass("js-password-strength")) {
                this.checkStrength();
            }
        }
        hasValue ? this.iconHelper.drawDeleteIcon() : this.iconHelper.resetIcon();
    }
    blur() {
        this.$elem.removeClass("active");
        if ($(".js-password-strength").hasClass("field-error")) {
            $(".ax-password-validation__label").not(".valid").addClass("invalid");
        }
        this.iconHelper.drawValidOrResetIcon();
    }
    iconClick() {
        if (this.isPassword) {
            let inputTypePassword = this.$elem.attr("type") === "password";
            this.$elem.attr("type", inputTypePassword ? "text" : "password");
            this.$icon.removeClass().addClass(inputTypePassword ? "lar la-eye-slash" : "lar la-eye");
            return;
        }
        this.$elem.val("").removeClass("value valid").trigger('change');
        this.iconHelper.resetIcon();
    }
    checkStrength() {
        let strength = 0;
        let password = this.$elem.val();
        let $passwordStrength = this.$parent.find(".password-strength");
        let $progressText = this.$parent.find(".progress-text");
        let $lengthCheckIndicator = this.$passwordValidiation.find(".js-pw-char");
        let $lowerCaseCheckIndicator = this.$passwordValidiation.find(".js-pw-lower");
        let $upperCaseCheckIndicator = this.$passwordValidiation.find(".js-pw-upper");
        let $numberCheckIndicator = this.$passwordValidiation.find(".js-pw-num");
        let $specialCharCheckIndicator = this.$passwordValidiation.find(".js-pw-spec-char");
        this.$parent.find(".ax-progress-wrapper").toggleClass("visible", password != '');
        if (this.$elem.hasClass("field-error")) {
            this.$passwordValidiation.find(".ax-password-validation__label").not(".valid").addClass("invalid");
        }
        if (/^(.{8,}$)/.test(password)) {
            strength += 1;
            $lengthCheckIndicator.addClass("valid").removeClass("invalid");
        }
        else {
            $lengthCheckIndicator.removeClass("valid");
        }
        if (/^(?=.*[a-z])/.test(password)) {
            strength += 1;
            $lowerCaseCheckIndicator.addClass("valid").removeClass("invalid");
        }
        else {
            $lowerCaseCheckIndicator.removeClass("valid");
        }
        if (/^(?=.*[A-Z])/.test(password)) {
            strength += 1;
            $upperCaseCheckIndicator.addClass("valid").removeClass("invalid");
        }
        else {
            $upperCaseCheckIndicator.removeClass("valid");
        }
        if (/^(?=.*[0-9])/.test(password)) {
            strength += 1;
            $numberCheckIndicator.addClass("valid").removeClass("invalid");
        }
        else {
            $numberCheckIndicator.removeClass("valid");
        }
        if (/^(?=.*[@#$%&!\.\(\)\{\}\[\]\^\$\*\+\-\?\/\|\—\/])/.test(password)) {
            strength += 1;
            $specialCharCheckIndicator.addClass("valid").removeClass("invalid");
        }
        else {
            $specialCharCheckIndicator.removeClass("valid");
        }
        if (strength < 2) {
            $passwordStrength.removeClass("progress-bar-warning");
            $passwordStrength.removeClass("progress-bar-success");
            $passwordStrength.addClass("progress-bar-danger");
            $passwordStrength.css("width", "30%");
            $progressText.text("weak");
        }
        else if (strength == 4) {
            $passwordStrength.removeClass("progress-bar-success");
            $passwordStrength.removeClass("progress-bar-danger");
            $passwordStrength.addClass("progress-bar-warning");
            $passwordStrength.css("width", "65%");
            $progressText.text("medium");
        }
        else if (strength == 5) {
            $passwordStrength.removeClass("progress-bar-warning");
            $passwordStrength.removeClass("progress-bar-danger");
            $passwordStrength.addClass("progress-bar-success");
            $passwordStrength.css("width", "100%");
            $progressText.text("strong");
            this.$passwordValidiation.hide();
        }
    }
}
